export default __webpack_public_path__ + "static/HealthBill-90da24731baa1b55eff8e9497f627e01.png";